import { tenantBootstrapRuntime } from "../services/tenantBootstrap";

export const getTenantFromPath = (pathname) =>
  tenantBootstrapRuntime.getTenantSlugFromPath(pathname);

export const getCompanyInformation = () => {
  const tenant = tenantBootstrapRuntime.getCurrentTenantBootstrap();

  return {
    tenantSlug:
      tenant?.tenantSlug || getTenantFromPath(window.location.pathname) || null,
    companyName: tenant?.clientName || null,
    companyLogo: tenant?.companyLogoUrl || null,
  };
};
